export interface AutoLayoutConfig {
  cols: number;
  rows: number;
}

export function getAutoLayout(imageCount: number): AutoLayoutConfig {
  if (imageCount <= 0) return { cols: 1, rows: 1 };

  switch (imageCount) {
    case 1:
      return { cols: 1, rows: 1 };
    case 2:
      return { cols: 2, rows: 1 };
    case 3:
      return { cols: 3, rows: 1 };
    case 4:
      return { cols: 2, rows: 2 };
    case 5:
    case 6:
      return { cols: 3, rows: 2 };
    case 7:
    case 8:
    case 9:
      return { cols: 3, rows: 3 };
    default:
      const cols = Math.ceil(Math.sqrt(imageCount));
      const rows = Math.ceil(imageCount / cols);
      return { cols, rows };
  }
}
